import { render, staticRenderFns } from "./DashboardIsfpPsfpSerieTemporalPsfpTendencia.vue?vue&type=template&id=5331bed2&scoped=true&"
import script from "./DashboardIsfpPsfpSerieTemporalPsfpTendencia.vue?vue&type=script&lang=js&"
export * from "./DashboardIsfpPsfpSerieTemporalPsfpTendencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5331bed2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VProgressCircular,VSelect,VSpacer})
